export const DOCUMENT_NAMES = {
  PERSONAL_DETAILS: 'personalDetails',
  BANK_DETAILS: 'bankDetails',
  TFN_DECLARATION: 'tfnDeclaration',
  SUPERANNUATION: 'superannuation',
  TAX_DETAILS: 'taxDetails',
  WORK_RIGHTS: 'workRights',
  ADDITIONAL_QUESTIONS: 'additionalQuestions',
  DOC_SIGNATURE_REQUESTS: 'docSignatureRequests',
  FILE_UPLOADS: 'fileUploads',
  EMPLOYMENT_ELIGIBILITY_VERIFICATION: 'employmentEligibilityVerification',
  FEDERAL_TAX_FORM: 'federalTaxForm',
  STATE_TAX_FORM: 'stateTaxForm',
  I9: 'employmentEligibilityVerification',
  SUPER_API: 'superAPI',
};

export const PERSONAL_DETAILS = {
  TITLE: 'personalDetails.title',
  FIRST_NAME: 'personalDetails.firstName',
  LAST_NAME: 'personalDetails.lastName',
  EMAIL: 'personalDetails.email',
  MOBILE: 'personalDetails.mobile',
  PREFERRED_NAME: 'personalDetails.preferredName',
  GENDER: 'personalDetails.gender',
  DOB: 'personalDetails.dob',
  ADDRESS: 'personalDetails.address',
  EMERGENCY_CONTACT_NAME: 'personalDetails.emergencyContactName',
  EMERGENCY_CONTACT_MOBILE: 'personalDetails.emergencyContactMobile',
  EMERGENCY_CONTACT_RELATIONSHIP:
    'personalDetails.emergencyContactRelationship',
};

export const BANK_DETAILS = {
  ACCOUNT_NAME: 'bankDetails.accountName',
  BANK_NAME: 'bankDetails.bankName',
  BSB: 'bankDetails.bsbNumber',
  SORT_CODE: 'bankDetails.sortCode',
  ACCOUNT_NUMBER: 'bankDetails.accountNumber',
};

export const TFN_DECLARATION = {
  OPTION: 'tfnDeclaration.option',
  TFN: 'tfnDeclaration.number',
  REASON: 'tfnDeclaration.reason',
  TITLE: 'tfnDeclaration.personalDetails.title',
  NAME: 'tfnDeclaration.personalDetails.FullName',
  PAY_BASIS: 'tfnDeclaration.taxDetails.payBasis',
  RESIDENT_STATUS: 'tfnDeclaration.taxDetails.residentStatus',
  COUNTRY_OF_ORIGIN: 'tfnDeclaration.taxDetails.countryOfOrigin',
  TAX_FREE_THRESHOLD: 'tfnDeclaration.taxDetails.taxFreeThreshold',
  HELP_LOAN_OR_STUDENT_DEBT: 'tfnDeclaration.taxDetails.hasLoanOrStudentDebt',
  DECLARATION: 'tfnDeclaration.taxDetails.declareTrueAndCorrect',
};

export const TFN_RESIDENT_STATUS_VALUES = {
  RESIDENT: 'resident',
  FOREIGN: 'foreign',
  WORKING_HOLIDAY: 'working-holiday',
};
export const SUPERANNUATION = {
  OPTION: 'superannuation.option',
  TYPE: 'superannuation.type',
  NAME: 'superannuation.name',
  TFN: 'superannuation.tfn.number',
  FUND_NAME: 'superannuation.fund',
  MEMBER_NUMBER: 'superannuation.fundMember',
  SELF_MANAGED: 'superannuation.selfManaged',
  SELF_MANAGED_FORM: 'superannuation.selfManagedForm',
  DECLARATION: 'superannuation.declareTrueAndCorrect',
};

export const TAX_DETAILS = {
  NATIONAL_INSURANCE_NUMBER: 'taxDetails.number',
  REASON: 'taxDetails.reason',
  STUDENT_LOAN: 'taxDetails.loan.option',
  LOAN_PLANS: 'taxDetails.loan.plans',
  P45: 'taxDetails.p45',
  P45_UPLOAD: 'taxDetails.p45upload',
  DECLARATION: 'taxDetails.declareTrueAndCorrect',
};

// The constant is for UK Region ONLY
export const WORK_RIGHTS_UK_FIELDS = {
  RESIDENCY: 'workRights.residency',
  SHARE_CODE: 'workRights.shareCode',
  PASSPORT: 'workRights.passport',
  BIRTH_CERTIFICATE: 'workRights.birthCertificate',
  SUPPORTING_DOCUMENTS: 'workRights.supportingDocuments',
};

export const WORK_RIGHTS_UK_VALUES = {
  BRITISH_IRISH: 'BritishIrish',
  OTHER_RESIDENCE: 'Other',
};

// For AU Region ONLY (Since AU and UK RTW are different)
export const WORK_RIGHTS_AU_FIELDS = {
  RESIDENCY: 'workRights.residencyStatus',
  DOC_TYPE: 'workRights.docType',
  BIRTH_CERTIFICATE: 'workRights.birthCertificate',
  PHOTO_ID: 'workRights.photoId',
  PASSPORT_NUMBER: 'workRights.passportNumber',
  PASSPORT: 'workRights.passport',
  COUNTRY_OF_DOCUMENT: 'workRights.countryOfDocument',
  TERMS_AND_CONDITIONS: 'workRights.termsAndConditions',
  SUBMISSION_CONSENT_TEXT: 'workRights.submissionConsentText',
};

export const WORK_RIGHTS_AU_RESIDENCY_VALUES = {
  AU_CITIZEN: 'auCitizen',
  NZ_CITIZEN: 'nzCitizen',
  OTHER: 'other',
};

export const WORK_RIGHTS_AU_DOC_TYPE_VALUES = {
  AU_PASSPORT: 'auPassport',
  BIRTH_CERTIFICATE_AND_PHOTO_ID: 'birthCertificateAndPhotoId',
  FOREIGN_PASSPORT: 'foreignPassport',
};
